import React from 'react'
import HomeSection from './Section/Home_Section'
import YouthPrograms from './YouthPrograms/YouthPrograms'
import StoriesSection from './Stories/Stories'
import { homePageHelmet } from '../../helmet';

const HomeArticles = React.lazy(() => import('./Articles/Articles'));

const HomePage = () => {
  

 /*  load homepage Articles data */


  return (
    <>
    {homePageHelmet()}
    <div className='homepage'>
      <main>
        <HomeSection/>
        <YouthPrograms/>
        <StoriesSection/>
        <HomeArticles/>
      </main>
    </div></>
  )
}

export default HomePage